export const CBR_ACC_SLOTS_LOADING_STATUS = {
  INACTIVE: 'inactive',
  IN_PROGRESS: 'in_progress',
  FAILED: 'failed'
}

export const CBR_ACC_SLOTS_LOADING_STATUS_COLOR = {
  INACTIVE: '#58d08d',
  IN_PROGRESS: '#fb8c00',
  FAILED: '#ff5252'
}

export const VIOLET_COLOR = '#791571';

export const FILTERS_ARGS = {
  SEARCH: 'search',
  EXAM_DATE_AFTER: 'exam_date_after',
  EXAM_DATE_BEFORE: 'exam_date_before',
  EXAM_LOCATION: 'exam_location'
}

export const CM_MODES = {
  MULTI: 'multi',
  SINGLE: 'single'
}

export const CM_HEADERS = [
  { text: '', value: 'edit', class: 'app-table__h_small cell-btns', sortable: false },
  { text: '№', value: 'number', class: 'app-table__h_small cell-index ', align: 'left',  sortable: false },
  { text: 'Color', value: 'color', class: 'app-table__h_small cell-index ', align: 'left',  sortable: true },
  { text: 'Placed/Paid', value: 'placed', align: 'left', class: 'nowrap cell-placed-paid', sortable: false },
  { text: 'Name', value: 'candidateName', align: 'left', class: 'cell-name' },
  {
    text: 'CDN',
    align: 'left',
    sortable: false,
    value: 'candidateNumber',
    class: 'nowrap cell-number'
  },
  { text: 'DOB/Phone', value: 'candidateBirthday', class: 'nowrap cell-bday', align: 'center' },
  { text: 'CBR', value: 'accountUsername', align: 'left', class: 'cell-cbr'},
  { text: 'App ID', value: 'appId', align: 'center', class: 'cell-appid text-center', sortable: false},
  { text: 'Payment', value: 'payment', sortable: false, class: 'cell-payment'},
  { text: 'Reserved Info', value: 'reserved', align: 'center', class: 'cell-reserved', sortable: true },
  { text: 'Product', value: 'productName', align: 'left', class: 'cell-product', sortable: true },
  { text: 'Status', value: 'status', align: 'left', class: 'cell-status' },
  { text: 'Comment', value: 'note', align: 'left', class: 'nowrap cell-app-note', sortable: false },
  { text: '', value: 'bov', align: 'center', class: 'nowrap cell-email', sortable: false },
  { text: 'Confirmed Courses', value: 'mainDate', align: 'left', class: 'cell-dates', sortable: false },
  { text: 'Reservation dates', value: 'requests', align: 'left', class: 'cell-reservation', sortable: false },
  { text: 'Note', value: 'note', align: 'center', sortable: false, class: 'cell-note' }, 
]

export const CURSSUSSEN_HEADERS = [
  { text: '', value: 'edit', class: 'app-table__h_small cell-btns', sortable: false },
  { text: '№', value: 'number', class: 'app-table__h_small cell-index ', align: 'left',  sortable: false },
  { text: 'Color', value: 'color', class: 'app-table__h_small cell-index ', align: 'left',  sortable: false },
  { text: 'Name', value: 'candidateName', align: 'left', class: 'cell-name' },
  {
    text: 'CDN',
    align: 'left',
    sortable: false,
    value: 'candidateNumber',
    class: 'nowrap cell-number'
  },
  { text: 'DOB/Phone', value: 'candidateBirthday', class: 'nowrap cell-bday', align: 'center' },
  { text: 'CBR', value: 'accountUsername', align: 'left', class: 'cell-cbr'},
  { text: 'Course Configuration', value: 'course_configuration', align: 'left', class: 'cell-configuration'},
  { text: 'App ID', value: 'appId', align: 'center', class: 'cell-appid text-center', sortable: false},
  { text: 'Payment', value: 'payment', sortable: false, class: 'cell-payment'},
  { text: 'Reserved Info', value: 'reserved', align: 'center', class: 'cell-reserved', sortable: false },
  { text: 'Product', value: 'productName', align: 'left', class: 'cell-product', sortable: false },
  { text: 'Will Come?', value: 'productName', align: 'left', class: 'cell-product', sortable: false },
  { text: 'Comment', value: 'note', align: 'left', class: 'nowrap cell-app-note', sortable: false },
  { text: '', value: 'bov', align: 'center', class: 'nowrap cell-email', sortable: false },
  { text: 'Note', value: 'note', align: 'center', sortable: false, class: 'cell-note' }, 
]

export const TRANSPORT_TYPE = {
  BUS: 'bus',
  TAXI: 'taxi',
  LOPEND: 'lopend',
  LANGLOPEN: 'langlopen'
}

export const TRANSPORT_TYPE_LIST = [TRANSPORT_TYPE.BUS, TRANSPORT_TYPE.TAXI, TRANSPORT_TYPE.LOPEND, TRANSPORT_TYPE.LANGLOPEN]
